import { render, staticRenderFns } from "./ListNotesContact.vue?vue&type=template&id=5cc2deec"
import script from "./ListNotesContact.vue?vue&type=script&lang=js"
export * from "./ListNotesContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports